import { render } from "./HowItWorksVouchersPage.vue?vue&type=template&id=862918fe&scoped=true"
import script from "./HowItWorksVouchersPage.vue?vue&type=script&lang=js"
export * from "./HowItWorksVouchersPage.vue?vue&type=script&lang=js"

import "./HowItWorksVouchersPage.vue?vue&type=style&index=0&id=862918fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862918fe"]])

export default __exports__